export default class ReportService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getReportFormData() {
		return this.apiService.callGet('reports/form_data')
	}

	getEntities(params) {
		return this.apiService.callGet('reports', params)
	}

	exportCsv(params, format, type) {
		return this.apiService.callGetFile('reports/export/'+format+'/'+type, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ReportsService.js